import classNames from 'classnames';
import { useEffect, type FC } from 'react';
import SimpleBar from '../../../../ReactSharedScripts/components/SimpleBar';
import { useStyleContextState } from '../../../../ReactSharedScripts/modules/styleContext';
import { ToolNavigationContent } from '../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationContent';
import syncManager from '../../../../ReactSharedScripts/utils/syncManager';
import classes from './styles/index.module.css';
import './styles/portal.css';
import { ToolNavigationCollapsedContent } from './components/ToolNavigationCollapsedContent';
import { useToolNavigationExpandedProvider } from './components/ToolNavigationExpandedProvider';
import { ToolNavigationHeader } from './components/ToolNavigationHeader';

export const ToolNavigation: FC = () => {
	const { theme } = useStyleContextState();
	const { isExpanded, toggleExpanded } = useToolNavigationExpandedProvider();

	const navClasses = classNames(classes.toolNavigation, {
		[classes.toolNavigation_expanded]: isExpanded,
	});

	useEffect(() => {
		const unsubscribe = syncManager.on('platform', 'toolNavigationToggle', () => {
			toggleExpanded();
		});

		return () => {
			unsubscribe();
		};
	}, [toggleExpanded]);

	return (
		<nav
			className={navClasses}
			data-testid='tool-navigation'
		>
			<SimpleBar
				style={{ height: '100%' }}
				theme={theme}
				classNameInner={classes.toolNavigation__contentWrapper}
			>
				<ToolNavigationHeader />
				{isExpanded ? <ToolNavigationContent /> : <ToolNavigationCollapsedContent />}
			</SimpleBar>
		</nav>
	);
};
